export const state = () => ({
  productIndexingList: []
});
